import * as React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * Generic yes/no confirmation dialog. Keep it presentational — the parent owns
 * the action and its loading state.
 */
export default function ConfirmDialog({
  open,
  title = "Are you sure?",
  message,
  content,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "primary",
  loading = false,
  onConfirm,
  onCancel,
}) {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={loading ? undefined : onCancel}
    >
      <DialogTitle className="font-bold uppercase">{title}</DialogTitle>
      <hr />
      <DialogContent>
        <DialogContentText className="text-base py-3 text-app-text-secondary">
          {message}
        </DialogContentText>
        {/* Outside the text element on purpose: inputs and other blocks cannot live inside a <p>. */}
        {content}
      </DialogContent>
      <hr />
      <DialogActions className="py-2">
        <Button onClick={onCancel} variant="outlined" color="inherit" disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color={confirmColor}
          disabled={loading}
          startIcon={loading && <CircularProgress size={16} color="inherit" />}
        >
          {loading ? "Please wait…" : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
